module.exports = __webpack_public_path__ + "img/RKD-PLUS-front.0a5da081.jpg";